export * from './featuredBanner.variants.defaults';
